import { kebabCase } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import useLookup from '../../../utils/useLookup';
const ContractSpecsRow = props => {
  const name = useLookup('Phase');
  const {
    data: {
      jobNumber,
      phase: propsDataPhase
    },
    index,
    id,
    onClick
  } = props;
  const handleClick = () => onClick(id);

  // Show that phase is not set... May not be needed - iPad does not have...
  const phase = propsDataPhase || /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'lightgray'
    }
  }, name, " not set");
  const classNames = classnames(`t-csr-${index}`, `t-csr-job-number-${kebabCase(jobNumber)}`, `t-csr-contract-spec-id-${kebabCase(id)}`);
  return /*#__PURE__*/React.createElement("tr", {
    className: classNames,
    onClick: handleClick,
    style: {
      height: '30px'
    }
  }, /*#__PURE__*/React.createElement("td", null, jobNumber), /*#__PURE__*/React.createElement("td", null, phase));
};
ContractSpecsRow.propTypes = {
  index: PropTypes.number.isRequired,
  data: PropTypes.shape({
    phase: PropTypes.string,
    jobNumber: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired
};
export default ContractSpecsRow;